import React from "react";
import styled from "styled-components";
import {HOSTING_URL} from "navigation-common/firebase-config";

export const Forbidden = () => {
    return (
        <ForbiddenWrapper>
            <CenteredVH>
                <img src={`${HOSTING_URL}/atl-assets/access-denied.svg`} alt="Lock symbol"/>
                <h2>Navigation Menus: Access denied</h2>
                <p>You dont have the correct permission to view the page <strong>Navigation Menus Overview</strong>.<br/>
                    Please request access from you Atlassian Cloud administrator.</p>
            </CenteredVH>
        </ForbiddenWrapper>
    )
};

const ForbiddenWrapper = styled.div`
  min-height: 700px;
`;

const CenteredVH = styled.div`
  h2 {
    margin: 40px 0 20px;
  }

  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.6;
  width: 600px;
  text-align: center;
`;
